export const notification = {
  all: "All",
  markAllButton: "Mark all as read",
  noData: "No notification",
  settingsButton: "Notification settings",
  unread: "Unread",
  upToDate: "You're all caught up",
  asyncDelete: {
    title: {
      organization: "Organization removal",
      location: "Location removal",
      asset: "Asset removal",
      assets: "Asset removal",
    },
    description: {
      success: {
        organization:
          "The organization <strong><em>{{modelName}}</em></strong> and associated data have been successfully deleted.",
        location:
          "The location <strong><em>{{modelName}}</em></strong> and associated data have been successfully deleted.",
        asset:
          "The asset <strong><em>{{modelName}}</em></strong> and associated data have been successfully deleted.",
        assets:
          "The assets <strong><em>{{modelName}}</em></strong> and associated data have been successfully deleted.",
        assetBatch:
          "The assets <strong><em>{{modelName}}</em></strong> and {{count}} other assets, along with their associated data, were successfully deleted.",
      },
      failure:
        "An unexpected error occurred during the deletion. The development team has been notified of the issue and will resolve the situation shortly.",
    },
  },
  jobModule: {
    completed: {
      title: "{{moduleName}}",
      description:
        'Module "{{moduleName}}" is finished - <strong><em>{{subjectName}}</em></strong>',
    },
    failed: {
      title: "Generation error",
      description:
        "An error occurred while generating the module: <strong><em>{{moduleName}}</em></strong>. Please contact support for assistance.",
    },
  },
  observationCommented: {
    title: "New comment",
  },
  interventionTransition: {
    title: "Intervention state changed",
    description_one:
      '{{userName}} changed the state of the intervention "{{interventionName}}" to <StateTag/>.',
    description_other:
      "{{userName}} changed the state of {{count}} interventions to <StateTag/>.",
  },
  observationTransition: {
    title: "Observation state changed",
    description_one:
      '{{userName}} changed the state of the observation "{{observationName}}" to <StateTag/>.',
    description_other:
      "{{userName}} changed the state of {{count}} observations to <StateTag/>.",
  },
};
